let constants = null;

export const getConstants = () => {
  if (!constants) {
    constants = {
      URL_API: process.env.VUE_APP_BACKEND_URL,
      SYSTEM_NAME: process.env.VUE_APP_SYSTEM_NAME,
      SYSTEM_VERSION: process.env.VUE_APP_SYSTEM_VERSION,
      SYSTEM_OWNER_NAME: process.env.VUE_APP_SYSTEM_OWNER_NAME,
      SYSTEM_BASE_URL: process.env.VUE_APP_SYSTEM_BASE_URL,
    };
  }
  return constants;
};
